export enum EVENT {
  APP_CONFIG_REQUEST = 'APP/CONFIG/REQUESTED',
  APP_CONFIG_RECEIVED = 'APP/CONFIG/RECEIVED',
}
